import { FormikErrors } from 'formik';
import { MultiValue } from 'react-select';

import { Registry } from '@/react/portainer/registries/types/registry';
import { AppliedPolicy } from '@/react/portainer/environments/types';
import { PolicyOverrideAlert } from '@/react/portainer/policies/components/PolicyOverrideAlert';

import { InlineLoader } from '@@/InlineLoader';
import { FormControl } from '@@/form-components/FormControl';
import { FormSection } from '@@/form-components/FormSection';
import { TextTip } from '@@/Tip/TextTip';

import { RegistriesSelector } from './RegistriesSelector';

type Props = {
  values: MultiValue<Registry>;
  onChange: (value: MultiValue<Registry>) => void;
  errors?: string | string[] | FormikErrors<Registry>[];
  isEditingDisabled: boolean;
  registryOptions?: Registry[];
  isLoadingRegistries: boolean;
  registryPolicy?: AppliedPolicy;
};

export function RegistriesFormSection({
  values,
  onChange,
  errors,
  isEditingDisabled,
  registryOptions,
  isLoadingRegistries,
  registryPolicy,
}: Props) {
  const hasRegistryPolicyApplied = !!registryPolicy?.policyID;
  const readOnlyMode = isEditingDisabled || hasRegistryPolicyApplied;
  return (
    <>
      {hasRegistryPolicyApplied && (
        <PolicyOverrideAlert
          policyName={registryPolicy?.policyName || ''}
          policyId={registryPolicy?.policyID || 0}
          policyType="registry-k8s"
        />
      )}
      <FormSection title="Registries">
        {!readOnlyMode && (
          <TextTip color="blue" className="mb-2">
            Define which registries can be used by users who have access to this
            namespace.
          </TextTip>
        )}
        <FormControl
          inputId="registries"
          label={readOnlyMode ? 'Selected registries' : 'Select registries'}
          errors={errors}
        >
          {isLoadingRegistries && (
            <InlineLoader>Loading registries...</InlineLoader>
          )}
          {registryOptions && (
            <RegistriesSelector
              value={values}
              onChange={(registries) => onChange(registries)}
              options={registryOptions}
              inputId="registries"
              isEditingDisabled={readOnlyMode}
            />
          )}
        </FormControl>
      </FormSection>
    </>
  );
}
